import { render, staticRenderFns } from "./EditMyLearnedLanguagesDialog.vue?vue&type=template&id=519f50d1&scoped=true&"
import script from "./EditMyLearnedLanguagesDialog.vue?vue&type=script&lang=js&"
export * from "./EditMyLearnedLanguagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditMyLearnedLanguagesDialog.vue?vue&type=style&index=0&id=519f50d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f50d1",
  null
  
)

export default component.exports